<div class="tv-container">
    <div class="main-display" [class.blink-animation]="isFlashing">
        <div class="label-current">Numéro appelé</div>

        @if (outgoingAnimationActive && outgoingTicketNumber !== null) {
            <div class="ticket-outgoing"> {{ outgoingTicketNumber }} </div>
        }

        <div class="ticket-current" [class.promoted-in]="currentTicketAnimationClass === 'promoted-in'">
            {{ currentTicket?.number || '--' }}
        </div>

        <div class="join-queue-panel">
            <div class="join-queue-text">
                Scanner pour rejoindre la file
            </div>
            <div class="join-queue-qr-wrapper">
                <img [src]="joinQueueQrUrl" alt="QR code pour rejoindre la file d'attente" class="join-queue-qr" />
                <div class="join-queue-url">{{ joinQueueUrl }}</div>
            </div>
        </div>
    </div>

    <div class="sidebar">
        <div class="sidebar-header">Dans la file</div>

        <div class="waiting-list">
            @if (waitingList && waitingList.length == 0) {
                <div class="empty-list">
                    Aucune attente
                </div>
            }
            @else {
                @for(t of waitingList; track t.id) {
                    <div class="waiting-item" [ngClass]="getWaitingItemClass(t, $index)">
                        <span>{{ t.number }}</span>
                        <span class="status-text">En attente</span>
                    </div>
                }
            }
        </div>
    </div>
</div>
